import { FilterValueModifier } from "consts/filters";
import { Filters } from "consts/waMessaging";
import { RequestQueryMapper } from "util/request-query-mapper";

export default function useRequestQueryOverrideDecorator(
    requestQueryAggregator: (
        fontendQueryParams: URLSearchParams,
        backendQueryParams: URLSearchParams
    ) => void
) {
    return (
        fontendQueryParams: URLSearchParams,
        backendQueryParams: URLSearchParams
    ) => {
        RequestQueryMapper.applyWithCustomQueryAggregator({
            fontendQueryParams,
            backendQueryParams,
            queryExtensionMap: new Map<
                string,
                (values: string[], requestQueryMapper: RequestQueryMapper) => void
            >()
                .set(Filters.transactionStatuses, (values: string[], requestQueryMapper: RequestQueryMapper) => {
                    requestQueryMapper.checkWithModifier(Filters.transactionStatuses, FilterValueModifier.Contains);

                    values.forEach(value => requestQueryMapper.values(Filters.transactionStatuses, value));
                })
        });

        return requestQueryAggregator(fontendQueryParams, backendQueryParams);
    };
};
